import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { alpha, Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, InputAdornment, InputLabel, Pagination, Paper, Snackbar, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useGetInvoiceIdListMutation, useGetRecruiterPaidAmountListMutation, useGetRecruiterPaymentListMutation, useGetRecruiterPendingAndRefundListMutation, useGetRecruiterRefundAmountListMutation, useGetRecruiterUnPaidAmountListMutation, useInvoiceSaveMutation } from "../../redux/Payments/PaymentHistory.api";
import dayjs from "dayjs";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import BonusIcon from '../../assets/bonus.png';
import Folders from '../../assets/folders.png';
import './paymentHistory.css';
import { TableLoader } from "../../reusable_components/components/TableLoader";
import MUIButton from '../../reusable_components/components/MUIButton';
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ORLOGO from "../../assets/or1.svg";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '../../assets/deleteIcon.png';
import { Card, CardContent, } from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PersonIcon from '@mui/icons-material/Person';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import handshake from '../../assets/handshake.png'
import { LuHistory } from "react-icons/lu";
import { useFetchPaymentHistoryMutation } from "../../redux/commissionManagement/commissionManagement.api";
import CloseIcon from "@mui/icons-material/Close";

const PaymentHistory = () => {

    const [value, setValue] = useState('1');
    const location = useLocation()
    const navigate = useNavigate()
    const { Snackbar } = useContext(SnackbarContext)
    const { recruiterFullName, recruiterId, recruiterEmail, recruiterBankName, recruiterBranchName, recruiterAccountNumber, recruiterIfscCode, pathName } = location?.state || ''

    const [getPaymentHistory] = useGetRecruiterPaymentListMutation()
    const [getRecruiterPaidAmountList] = useGetRecruiterPaidAmountListMutation()
    const [getUnpaidPaymentHistory] = useGetRecruiterUnPaidAmountListMutation()
    const [getRefundAmountHistory] = useGetRecruiterRefundAmountListMutation()
    const [InvoiceSave] = useInvoiceSaveMutation()
    const [getInvoiceIdList] = useGetInvoiceIdListMutation()
    const [getHistory] = useFetchPaymentHistoryMutation()

    const [invoiceNumber, setInvoiceNumber] = useState('')
    const [Paymentdetails, setPaymentDetails] = useState([])
    const [paidPaymentList, setPaidPaymentList] = useState([])
    const [UnpaidPaymentList, setUnpaidPaymentList] = useState([])
    const [refundAmountList, setRefundAmountList] = useState([])
    const [allInvoiceList, setAllInvoiceList] = useState([])
    const [showTableLoder, setShowTableLoder] = useState(false)
    const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false)
    const [isInvoice, setIsInvoice] = useState(false)
    const [pendingSet, setPendingSet] = useState(new Set())
    const [refundSet, setRefundSet] = useState(new Set())
    const [currentDate, setCurrentDate] = useState(new Date().toLocaleDateString());
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const [history, setHistory] = useState([])
    const [openHistory, setOpenHistory] = useState(false)
    const [showLoader, setShowLoader] = useState(false);


    const [count, setCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(1);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleNavigationBack = () => {
        // navigate(pathName)
        navigate(-1)
    }

    const handleGetInvoiceNumber = (e) => {
        setInvoiceNumber(e.target.value)

    }


    const [amount, setAmount] = useState([])
    const [refund, setRefund] = useState([])

    const handleInvoiceOpen = () => {
        const paymentAmounts = Array.from(pendingSet).map((data) => data?.paymentAmount)
        setAmount(paymentAmounts)
        const refundAmounts = Array.from(refundSet).map((data) => data?.refundAmount)
        setRefund(refundAmounts)
        setInvoiceDialogOpen(true)
    }

    const paymentTotal = amount?.reduce((arr, crr) => arr + crr, 0) || 0
    const refundTotal = refund?.reduce((acc, cur) => acc + cur, 0) || 0
    const finalAmount = paymentTotal - refundTotal || 0

    const handleClose = () => {
        setInvoiceDialogOpen(false)
        setInvoiceNumber('')
        setIsInvoice(false)
    }

    const handlePendingCheck = (payment) => {
        setPendingSet(prev => {
            const updatedSet = new Set(prev);
            if (updatedSet.has(payment)) {
                updatedSet.delete(payment);
            } else {
                updatedSet.add(payment);
            }
            return updatedSet;
        });
    }

    const handleRefundChecked = (refund) => {
        setRefundSet(prev => {
            const updatedSet = new Set(prev);
            if (updatedSet.has(refund)) {
                updatedSet.delete(refund);
            } else {
                updatedSet.add(refund);
            }
            return updatedSet;
        });
    }


    const getPaymentTableDatas = async () => {
        try {
            const payload = {
                page: page - 1,
                size: rowsPerPage,
                userId: recruiterId
            }
            setShowTableLoder(true)
            const response = await getPaymentHistory(payload).unwrap()
            setShowTableLoder(false)
            setPaymentDetails(response?.response?.referralCommissionDetails)
            setCount(response?.response?.totalCount)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const getPaidAmountDetails = async () => {
        try {
            const payload = {
                page: page - 1,
                size: rowsPerPage,
                userId: recruiterId
            }
            setShowTableLoder(true)
            const response = await getRecruiterPaidAmountList(payload).unwrap()
            setShowTableLoder(false)
            setPaidPaymentList(response?.response?.referralCommissionDetails)
            setCount(response?.response?.totalCount)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const getUnpaidPaymentDatas = async () => {
        try {
            const payload = {
                page: page - 1,
                size: rowsPerPage,
                userId: recruiterId
            }
            setShowTableLoder(true)
            const response = await getUnpaidPaymentHistory(payload).unwrap()
            setShowTableLoder(false)
            setUnpaidPaymentList(response?.response?.referralCommissionDetails)
            setCount(response?.response?.totalCount)


        } catch (error) {
            Snackbar('Network error', 'error')
        }
    }

    const getRefundAmountDatas = async () => {
        try {
            const payload = {
                page: page - 1,
                size: rowsPerPage,
                userId: recruiterId
            }
            setShowTableLoder(true)
            const response = await getRefundAmountHistory(payload).unwrap()
            setShowTableLoder(false)
            setRefundAmountList(response?.response?.referralCommissionDetails)
            setCount(response?.response?.totalCount)

        } catch (error) {
            Snackbar('Network error', 'error')
        }
    }

    const makeInvoice = async () => {

        if (invoiceNumber.length === 0) {
            setIsInvoice(true)
        } else {

            const pendingIdArray = Array.from(pendingSet).map((pending) => pending?.paymentId)
            const refundIdArray = Array.from(refundSet).map((refund) => refund?.refundId)

            try {
                const payload = {
                    invoiceId: null,
                    invoiceNumber: invoiceNumber,
                    userId: recruiterId,
                    paymentIds: pendingIdArray,
                    refundIds: refundIdArray,
                    totalAmount: finalAmount,
                }
                setShowTableLoder(true)
                const response = await InvoiceSave(payload).unwrap()
                setShowTableLoder(false)
                Snackbar(response?.response?.message, 'success')
                setInvoiceDialogOpen(false)
                getUnpaidPaymentDatas()
                getRefundAmountDatas()

            } catch (error) {
                Snackbar('Network error', 'error')
            }
        }
    }

    const getAllInvoiceDatas = async () => {
        try {
            const payload = {
                page: page - 1,
                size: 10,
                userId: recruiterId
            }
            setShowTableLoder(true)
            const response = await getInvoiceIdList(payload).unwrap()
            setShowTableLoder(false)
            setAllInvoiceList(response?.response?.invoiceIdDetailsList)
            setCount(response?.response?.totalCount)


        } catch (error) {
            Snackbar("Networ error", 'error')
        }
    }


    useEffect(() => {


    }, [invoiceNumber])


    useEffect(() => {
        if (value === '1') {
            getPaymentTableDatas()
        } else if (value === '2') {
            getPaidAmountDetails()
        } else if (value === '3') {
            getUnpaidPaymentDatas()
        } else if (value === '4') {
            getRefundAmountDatas()
        } else if (value === '5') {
            getUnpaidPaymentDatas()
            getRefundAmountDatas()
            setPendingSet(new Set())
            setRefundSet(new Set())
            setInvoiceNumber('')
        } else if (value === '6') {
            getAllInvoiceDatas()
        }
    }, [value, page])

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleGetCommissionHistory = async (item) => {
        setOpenHistory(true)
        setShowLoader(true)
        try {
            const payload = {
                referralCommissionPaymentId: item?.paymentId || item?.referralCommissionPaymentId
            }

            const res = await getHistory(payload).unwrap()
            setHistory(res?.response)
            setShowLoader(false)
        } catch (error) {
            Snackbar('Netwrok error', 'error')
            console.error("Failed to fetch history");
            setShowLoader(false)
        }
    }

    const handleCloseHistory = () => {
        setOpenHistory(false)
        setHistory([])
    }

    const StatusBadge = ({ status }) => {
        const statusConfig = {
            pending: { color: "#F79009", bgColor: "#FFFAEB" },
            paid: { color: "#3ebe82ff", bgColor: "#ECFDF3" },
            approved: { color: "#12B76A", bgColor: "#ECFDF3" },
            rejected: { color: "#F04438", bgColor: "#FEF3F2" },
            refunded: { color: "#7F56D9", bgColor: "#F9F5FF" },
            rra: { color: "#ba2828ff", bgColor: "#f7f2f2ff" },
            default: { color: "#667085", bgColor: "#F2F4F7" },
        };

        const config = statusConfig[status?.toLowerCase()] || statusConfig.default;

        return (
            <Chip
                label={status === "RRA" ? "Refund & Return" : status}
                size="small"
                sx={{
                    backgroundColor: config.bgColor,
                    color: config.color,
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    border: `1px solid ${config.color}30`,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: `0 4px 12px ${alpha(config.color, 0.2)}`,
                    },
                }}
            />
        );
    };


    return (
        <Box className="container">
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={handleNavigationBack}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '15px', flexWrap: 'wrap' }}>
                <Box>
                    <Card
                        sx={{
                            maxWidth: 600,
                            width: '100%',
                            mx: 'auto',
                            boxShadow: 6,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #f0f4ff, #ffffff)'
                        }}>
                        <CardContent>
                            <Grid2 container spacing={1} direction="column">
                                <Grid2 sx={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '14px' }} >{recruiterId} {recruiterFullName}<br></br> {recruiterEmail}</Typography>
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Box>

                <Typography className="title" >Payment History</Typography>

                <Box>
                    <Card
                        sx={{
                            maxWidth: 600,
                            width: '100%',
                            mx: 'auto',
                            boxShadow: 6,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #f0f4ff, #ffffff)',
                        }}
                    >
                        <CardContent sx={{ paddingBottom: '2px !important' }}>
                            <Grid2 container spacing={1} direction="column">

                                <Grid2 container spacing={1} sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <AccountBalanceOutlinedIcon sx={{ color: '#1976d2' }} />
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: 'Roboto Slab, serif',
                                            fontWeight: 'bold',
                                            color: '#1976d2',
                                        }}
                                    >
                                        {recruiterBankName} - {recruiterBranchName}
                                    </Typography>
                                </Grid2>

                                <Grid2 container spacing={1} sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <AccountBalanceWalletIcon className="icons" />
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: 'Roboto Slab, serif',
                                        }}
                                    >
                                        <span style={{ fontWeight: 'bold' }}>  A/C No:</span> {recruiterAccountNumber}
                                    </Typography>
                                </Grid2>

                                <Grid2 container spacing={1} sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <VpnKeyIcon className="icons" />
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: 'Roboto Slab, serif',
                                        }}
                                    >
                                        <span style={{ fontWeight: 'bold' }}> IFSC Code: </span>    {recruiterIfscCode}
                                    </Typography>
                                </Grid2>

                            </Grid2>
                        </CardContent>
                    </Card>
                </Box>

                {/* <Grid2>
                    <Typography sx={{ fontSize: '14px' }} >{recruiterBankName} {recruiterBranchName}<br></br>{recruiterAccountNumber}<br></br>{recruiterIfscCode}</Typography>
                </Grid2> */}
            </Box>

            <Grid2>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="Payment history tabs"
                            textColor="primary"
                            indicatorColor="secondary"
                        >
                            <Tab
                                label="All"
                                value="1"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "1" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />

                            <Tab
                                label="Paid"
                                value="2"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "2" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />

                            <Tab
                                label="Pending"
                                value="3"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "3" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />

                            <Tab
                                label="Refund"
                                value="4"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "4" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />

                            {/* <Tab
                                label="Invoice"
                                value="5"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "5" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />

                            <Tab
                                label="All Invoices"
                                value="6"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "6" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            /> */}

                        </TabList>
                    </Box>

                    <TabPanel value="1" sx={{ display: 'flex', padding: 1.5 }}>
                        <Paper sx={{ width: '100%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='tableHeadersCell'>Referral Type</TableCell>
                                        <TableCell className='tableHeadersCell'>Status</TableCell>
                                        <TableCell className='tableHeadersCell'>Rewards</TableCell>
                                        <TableCell className="tableHeadersCell">
                                            <Grid2 sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Payment Date</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Payment Amount</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Payment Status</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>History</Box>
                                            </Grid2>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    !showTableLoder ? (
                                        Paymentdetails?.length > 0 ? (
                                            Paymentdetails?.map((data, index) => (
                                                <TableBody key={data?.referralCommissionId}>
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >
                                                        <TableCell className='tableBodyCell'>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                {
                                                                    data?.referralType === "CAN-REF" ? (
                                                                        <img src={BonusIcon} alt="Bonus icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    ) : (data?.referralType === "CLI-REF" ? (
                                                                        <img src={handshake} alt="Hand shake icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    ) : (
                                                                        <img src={Folders} alt="Folders icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    ))
                                                                }
                                                                <Typography className='referral-column'>
                                                                    <span style={{ fontWeight: 'bold' }}>{data?.referralType}-{dayjs(data?.createdDate).format('YYYY')}-{data?.referralCommissionId}</span>
                                                                    <br />
                                                                    {
                                                                        data?.referralType === "CAN-REF" ? (
                                                                            <>
                                                                                {data?.profileName}
                                                                                <br />
                                                                                {data?.positionName}
                                                                            </>
                                                                        ) : (
                                                                            data?.referralType === 'CLI-REF' ? (
                                                                                <>
                                                                                    {data?.positionName}
                                                                                    <br />
                                                                                    {data?.profileName}
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    {data?.positionName}
                                                                                    <br />
                                                                                    {data?.profileName}
                                                                                </>
                                                                            ))
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            <Tooltip
                                                                title={data?.reasonForCancellation === "" ? "Reason is not given" : data?.reasonForCancellation}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span className={`badge-status ${data?.status?.toLowerCase()}`}>
                                                                    {data?.status === "Approved" ? "Approved" :
                                                                        data?.status === "PPAID" ? "Partially Paid" :
                                                                            data?.status === "Rejected" ? "Rejected" :
                                                                                data?.status === "REJRFND" ? "Refunded & Rejected" :
                                                                                    data?.status === "CLS" ? "Closed" :
                                                                                        data?.status === "Pending" ? "Pending" :
                                                                                            data?.status === "RRA" && "Refunded & Returned"}
                                                                </span>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            {
                                                                !data?.commissionType ? "-" : data?.commissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                            }
                                                            <br />
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                <Typography sx={{ fontSize: '12.5px' }}>
                                                                    {data?.commissionAmount}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell' sx={{ padding: '0px', borderLeft: '1px solid #E9EAEB' }}>
                                                            {data?.paymentDetails?.length > 0 ? (
                                                                <Box sx={{ width: '100%' }}>
                                                                    {data.paymentDetails.map((payment, paymentIndex) => (
                                                                        <Box
                                                                            key={paymentIndex}
                                                                            sx={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                padding: '8px 16px',
                                                                                borderBottom: paymentIndex < data.paymentDetails.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                            }}
                                                                        >
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Typography sx={{ fontSize: '12.5px', whiteSpace: 'nowrap' }}>
                                                                                    {dayjs(payment?.paymentDate).format('DD-MM-YYYY')}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                                        {payment?.paymentAmount}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <StatusBadge status={payment?.paymentStatus} />
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Tooltip
                                                                                    title="Payment History"
                                                                                    placement="top"
                                                                                    slotProps={{
                                                                                        tooltip: {
                                                                                            sx: {
                                                                                                backgroundColor: "#0A0D12",
                                                                                                borderRadius: "8px",
                                                                                                padding: "8px 12px",
                                                                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                            },
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <span>
                                                                                        <LuHistory
                                                                                            onClick={() => handleGetCommissionHistory(payment)}
                                                                                            style={{
                                                                                                fontSize: "17px",
                                                                                                cursor: "pointer",
                                                                                                color: "#b6bbbb",
                                                                                                transition: "transform 0.2s ease, color 0.2s ease",
                                                                                            }}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.color = "#5417cd";
                                                                                                e.currentTarget.style.transform = "scale(1.2)";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.color = "#b6bbbb";
                                                                                                e.currentTarget.style.transform = "scale(1)";
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                </Tooltip>
                                                                            </Box>
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        padding: '20px',
                                                                        color: '#999',
                                                                        fontStyle: 'italic',
                                                                        fontSize: '12.5px'
                                                                    }}
                                                                >
                                                                    No Payments
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            ))
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={4}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4}>
                                                <Box className='tableloader'>
                                                    <TableLoader />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                <TableRow>
                                    {count <= rowsPerPage ? "" : (
                                        <TableCell colSpan={4}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === 1}
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(count / rowsPerPage)}
                                                    siblingCount={3}
                                                    boundaryCount={3}
                                                    shape="rounded"
                                                    hidePrevButton
                                                    hideNextButton
                                                />
                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === Math.ceil(count / rowsPerPage)}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    )}
                                </TableRow>
                            </Table>
                        </Paper>
                    </TabPanel>

                    <TabPanel value="2" sx={{ display: 'flex', " &.MuiTabPanel-root": { padding: 0 }, }}>
                        <Paper sx={{ width: '100%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='tableHeadersCell'>Referral Type</TableCell>
                                        <TableCell className='tableHeadersCell'>Status</TableCell>
                                        <TableCell className='tableHeadersCell'>Rewards</TableCell>
                                        <TableCell className='tableHeadersCell'>
                                            <Grid2 sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Payment Date</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Payment Amount</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Payment Status</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    History
                                                </Box>
                                            </Grid2>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    !showTableLoder ? (
                                        paidPaymentList?.length > 0 ? (
                                            paidPaymentList?.map((data, index) => (
                                                <TableBody key={data?.referralCommissionId}>
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >
                                                        <TableCell className='tableBodyCell'>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                {
                                                                    data?.referralType === "CAN-REF" ? (
                                                                        <img src={BonusIcon} alt="Bonus icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    ) : (
                                                                        <img src={Folders} alt="Folders icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    )
                                                                }
                                                                <Typography className='referral-column'>
                                                                    <span style={{ fontWeight: 'bold' }}>{data?.referralType}-{dayjs(data?.createdDate).format('YYYY')}-{data?.referralCommissionId}</span>
                                                                    <br />
                                                                    {
                                                                        data?.referralType === "CAN-REF" ? (<>
                                                                            {data?.profileName}
                                                                            <br />
                                                                            {data?.positionName}
                                                                        </>) : (<>
                                                                            {data?.positionName}
                                                                            <br />
                                                                            {data?.profileName}
                                                                        </>)
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            <Tooltip
                                                                title={data?.reasonForCancellation === null ? "Reason is not given" : "......."}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span className={`badge-status ${data?.status?.toLowerCase()}`}>{data?.status}</span>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            {
                                                                !data?.commissionType ? "-" : data?.commissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                            }
                                                            <br />
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                <Typography sx={{ fontSize: '12.5px' }}>
                                                                    {data?.commissionAmount}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell' sx={{ padding: '0px', borderLeft: '1px solid #E9EAEB' }}>
                                                            {data?.paymentDetails?.length > 0 ? (
                                                                <Box sx={{ width: '100%' }}>
                                                                    {data.paymentDetails.map((payment, paymentIndex) => (
                                                                        <Box
                                                                            key={paymentIndex}
                                                                            sx={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                padding: '8px 16px',
                                                                                borderBottom: paymentIndex < data.paymentDetails.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                            }}
                                                                        >
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Typography sx={{ fontSize: '12.5px' }}>
                                                                                    {dayjs(payment?.paymentDate).format('DD-MM-YYYY')}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                                        {payment?.paymentAmount}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <StatusBadge status={payment?.paymentStatus} />
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Tooltip
                                                                                    title="Payment History"
                                                                                    placement="top"
                                                                                    slotProps={{
                                                                                        tooltip: {
                                                                                            sx: {
                                                                                                backgroundColor: "#0A0D12",
                                                                                                borderRadius: "8px",
                                                                                                padding: "8px 12px",
                                                                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                            },
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <span>
                                                                                        <LuHistory
                                                                                            onClick={() => handleGetCommissionHistory(payment)}
                                                                                            style={{
                                                                                                fontSize: "17px",
                                                                                                cursor: "pointer",
                                                                                                color: "#b6bbbb",
                                                                                                transition: "transform 0.2s ease, color 0.2s ease",
                                                                                            }}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.color = "#5417cd";
                                                                                                e.currentTarget.style.transform = "scale(1.2)";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.color = "#b6bbbb";
                                                                                                e.currentTarget.style.transform = "scale(1)";
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                </Tooltip>
                                                                            </Box>
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        padding: '20px',
                                                                        color: '#999',
                                                                        fontStyle: 'italic'
                                                                    }}
                                                                >
                                                                    No Payments
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            ))
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={4}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4}>
                                                <Box className='tableloader'>
                                                    <TableLoader />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                <TableRow>
                                    {count <= rowsPerPage ? ("") : (
                                        <TableCell colSpan={4}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === 1}
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(count / rowsPerPage)}
                                                    siblingCount={3}
                                                    boundaryCount={3}
                                                    shape="rounded"
                                                    hidePrevButton
                                                    hideNextButton
                                                />
                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === Math.ceil(count / rowsPerPage)}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    )}
                                </TableRow>
                            </Table>
                        </Paper>
                    </TabPanel>

                    <TabPanel value="3" sx={{ " &.MuiTabPanel-root": { padding: 0 } }}>
                        <Paper sx={{ width: '100%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='tableHeadersCell'>Referral Type</TableCell>
                                        <TableCell className='tableHeadersCell'>Status</TableCell>
                                        <TableCell className='tableHeadersCell'>Rewards</TableCell>
                                        <TableCell className='tableHeadersCell'>
                                            <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                <Box sx={{ flex: 1 }}>Payment Date</Box>
                                                <Box sx={{ flex: 1 }}>Payment Amount</Box>
                                                <Box sx={{ flex: 1 }}>Payment Status</Box>
                                                {/* <Box sx={{ flex: 1 }}>History</Box> */}
                                            </Grid2>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    !showTableLoder ? (
                                        UnpaidPaymentList?.length > 0 ? (
                                            UnpaidPaymentList?.map((data, index) => (
                                                <TableBody key={data?.referralCommissionId}>
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >
                                                        <TableCell className='tableBodyCell'>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                {
                                                                    data?.referralType === "CAN-REF" ? (
                                                                        <img src={BonusIcon} alt="Bonus icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    ) : (
                                                                        <img src={Folders} alt="Folders icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    )
                                                                }
                                                                <Typography className='referral-column'>
                                                                    <span style={{ fontWeight: 'bold' }}>{data?.referralType}-{dayjs(data?.createdDate).format('YYYY')}-{data?.referralCommissionId}</span>
                                                                    <br />
                                                                    {
                                                                        data?.referralType === "CAN-REF" ? (<>
                                                                            {data?.profileName}
                                                                            <br />
                                                                            {data?.positionName}
                                                                        </>) : (<>
                                                                            {data?.positionName}
                                                                            <br />
                                                                            {data?.profileName}
                                                                        </>)
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            <Tooltip
                                                                title={data?.reasonForCancellation}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span className={`badge-status ${data?.status?.toLowerCase()}`}>{data?.status}</span>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            {
                                                                !data?.commissionType ? "-" : data?.commissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                            }
                                                            <br />
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                <Typography sx={{ fontSize: '12.5px' }}>
                                                                    {data?.commissionAmount}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell' sx={{ padding: '0px', borderLeft: '1px solid #E9EAEB' }}>
                                                            {data?.paymentDetails?.length > 0 ? (
                                                                <Box sx={{ width: '100%' }}>
                                                                    {data.paymentDetails.map((payment, paymentIndex) => (
                                                                        <Box
                                                                            key={paymentIndex}
                                                                            sx={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                padding: '8px 16px',
                                                                                borderBottom: paymentIndex < data.paymentDetails.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                            }}
                                                                        >
                                                                            <Typography sx={{ flex: 1, fontSize: '12.5px' }}>
                                                                                {dayjs(payment?.paymentDate).format('DD-MM-YYYY')}
                                                                            </Typography>
                                                                            <Typography sx={{ flex: 1, fontSize: '12.5px' }}>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                                        {payment?.paymentAmount}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Typography>
                                                                            <Typography sx={{ flex: 1, textAlign: 'left', fontSize: '12.2px' }}>
                                                                                <StatusBadge status={payment?.paymentStatus} />
                                                                            </Typography>
                                                                            {/* Uncomment if you need the history column */}
                                                                            {/* <Box sx={{ flex: 1, textAlign: 'left' }}>
                                                    <Tooltip
                                                        title="Payment History"
                                                        placement="top"
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: "#0A0D12",
                                                                    borderRadius: "8px",
                                                                    padding: "8px 12px",
                                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <span>
                                                            <LuHistory
                                                                onClick={() => handleGetCommissionHistory(payment)}
                                                                style={{
                                                                    fontSize: "17px",
                                                                    cursor: "pointer",
                                                                    color: "#b6bbbb",
                                                                    transition: "transform 0.2s ease, color 0.2s ease",
                                                                }}
                                                                onMouseOver={(e) => {
                                                                    e.currentTarget.style.color = "#5417cd";
                                                                    e.currentTarget.style.transform = "scale(1.2)";
                                                                }}
                                                                onMouseOut={(e) => {
                                                                    e.currentTarget.style.color = "#b6bbbb";
                                                                    e.currentTarget.style.transform = "scale(1)";
                                                                }}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </Box> */}
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        padding: '20px',
                                                                        color: '#999',
                                                                        fontStyle: 'italic',
                                                                        fontSize: '12.5px'
                                                                    }}
                                                                >
                                                                    No Payments
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            ))
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={4}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4}>
                                                <Box className='tableloader'>
                                                    <TableLoader />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                <TableRow>
                                    {count <= rowsPerPage ? "" : (
                                        <TableCell colSpan={4}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === 1}
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(count / rowsPerPage)}
                                                    siblingCount={3}
                                                    boundaryCount={3}
                                                    shape="rounded"
                                                    hidePrevButton
                                                    hideNextButton
                                                />
                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === Math.ceil(count / rowsPerPage)}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    )}
                                </TableRow>
                            </Table>
                        </Paper>

                    </TabPanel>

                    <TabPanel value="4" sx={{ " &.MuiTabPanel-root": { padding: 0 } }}>
                        <Paper sx={{ width: '100%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='tableHeadersCell'>Referral Type</TableCell>
                                        <TableCell className='tableHeadersCell'>Status</TableCell>
                                        <TableCell className='tableHeadersCell'>Rewards</TableCell>
                                        <TableCell className='tableHeadersCell'>
                                            <Grid2 sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Refund Amount</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>Refund Status</Box>
                                                <Box sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    History
                                                </Box>
                                            </Grid2>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    !showTableLoder ? (
                                        refundAmountList?.length > 0 ? (
                                            refundAmountList?.map((data, index) => (
                                                <TableBody key={data?.referralCommissionId}>
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >
                                                        <TableCell className='tableBodyCell'>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                {
                                                                    data?.referralType === "CAN-REF" ? (
                                                                        <img src={BonusIcon} alt="Bonus icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    ) : (
                                                                        <img src={Folders} alt="Folders icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                    )
                                                                }
                                                                <Typography className='referral-column'>
                                                                    <span style={{ fontWeight: 'bold' }}>{data?.referralType}-{dayjs(data?.createdDate).format('YYYY')}-{data?.referralCommissionId}</span>
                                                                    <br />
                                                                    {
                                                                        data?.referralType === "CAN-REF" ? (<>
                                                                            {data?.profileName}
                                                                            <br />
                                                                            {data?.positionName}
                                                                        </>) : (<>
                                                                            {data?.positionName}
                                                                            <br />
                                                                            {data?.profileName}
                                                                        </>)
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            <Tooltip
                                                                title={data?.reasonForCancellation || "Reason is not given"}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <span className={`badge-status ${data?.status?.toLowerCase()}`}>{data?.status}</span>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            {
                                                                !data?.commissionType ? "-" : data?.commissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                            }
                                                            <br />
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                <Typography sx={{ fontSize: '12.5px' }}>
                                                                    {data?.commissionAmount}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell className='tableBodyCell' sx={{ padding: '0px', borderLeft: '1px solid #E9EAEB' }}>
                                                            {data?.refundDetails?.length > 0 ? (
                                                                <Box sx={{ width: '100%' }}>
                                                                    {data.refundDetails.map((refund, refundIndex) => (
                                                                        <Box
                                                                            key={refundIndex}
                                                                            sx={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                padding: '8px 16px',
                                                                                borderBottom: refundIndex < data.refundDetails.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                                backgroundColor: refundIndex % 2 === 0 ? 'transparent' : '#fafafa',
                                                                                '&:hover': {
                                                                                    backgroundColor: '#f5f5f5'
                                                                                }
                                                                            }}
                                                                        >
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                                        {refund?.refundAmount}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <StatusBadge status={refund?.refundStatus} />
                                                                            </Box>
                                                                            <Box sx={{
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Tooltip
                                                                                    title="Payment History"
                                                                                    placement="top"
                                                                                    slotProps={{
                                                                                        tooltip: {
                                                                                            sx: {
                                                                                                backgroundColor: "#0A0D12",
                                                                                                borderRadius: "8px",
                                                                                                padding: "8px 12px",
                                                                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                            },
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <span>
                                                                                        <LuHistory
                                                                                            onClick={() => handleGetCommissionHistory(refund)}
                                                                                            style={{
                                                                                                fontSize: "17px",
                                                                                                cursor: "pointer",
                                                                                                color: "#b6bbbb",
                                                                                                transition: "transform 0.2s ease, color 0.2s ease",
                                                                                            }}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.color = "#5417cd";
                                                                                                e.currentTarget.style.transform = "scale(1.2)";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.color = "#b6bbbb";
                                                                                                e.currentTarget.style.transform = "scale(1)";
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                </Tooltip>
                                                                            </Box>
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        padding: '20px',
                                                                        color: '#999',
                                                                        fontStyle: 'italic',
                                                                        fontSize: '12.5px'
                                                                    }}
                                                                >
                                                                    No Refunds
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            ))
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={4}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4}>
                                                <Box className='tableloader'>
                                                    <TableLoader />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                <TableRow>
                                    {count <= rowsPerPage ? "" : (
                                        <TableCell colSpan={4}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === 1}
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(count / rowsPerPage)}
                                                    siblingCount={3}
                                                    boundaryCount={3}
                                                    shape="rounded"
                                                    hidePrevButton
                                                    hideNextButton
                                                />
                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    disabled={page === Math.ceil(count / rowsPerPage)}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    )}
                                </TableRow>
                            </Table>
                        </Paper>

                    </TabPanel>

                    {/* <TabPanel value="5" sx={{ " &.MuiTabPanel-root": { padding: 0 } }}>
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '10px' }}>
                            <Paper sx={{ width: '100%' }}>
                                <Table sx={{ width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" >Pending</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='tableHeadersCell' >Referral Type</TableCell>
                                            <TableCell className='tableHeadersCell' >Rewards</TableCell>
                                            <TableCell className='tableHeadersCell' >
                                                <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <Box sx={{ flex: 1 }}>
                                                        Payment Amount
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        Payment Date
                                                    </Box>
                                                </Grid2>
                                            </TableCell>
                                        </TableRow>

                                    </TableHead>
                                    {
                                        !showTableLoder ? (
                                            UnpaidPaymentList?.length > 0 ? (
                                                UnpaidPaymentList?.map((data, index) => (
                                                    <TableBody>
                                                        <TableRow key={data?.referralCommissionId}
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}>
                                                            <TableCell className='tableBodyCell'>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                    {
                                                                        data?.referralType === "CAN-REF" ? (
                                                                            <img src={BonusIcon} alt="Bonus icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />

                                                                        ) : (
                                                                            <img src={Folders} alt="Folders icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                        )
                                                                    }
                                                                    <Typography className='referral-column'><span style={{ fontWeight: 'bold' }}>{data?.referralType}-{dayjs(data?.createdDate).format('YYYY')}-{data?.referralCommissionId}</span>
                                                                        <br></br>
                                                                        {
                                                                            data?.referralType === "CAN-REF" ? (<>
                                                                                {data?.profileName}
                                                                                <br></br>
                                                                                {data?.positionName}
                                                                            </>) : (<>
                                                                                {data?.positionName}
                                                                                <br></br>
                                                                                {data?.profileName}
                                                                            </>)
                                                                        }
                                                                    </Typography>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell'>
                                                                {
                                                                    !data?.commissionType ? "-" : data?.commissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                                }<br></br>

                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                        {data?.commissionAmount}
                                                                    </Typography>
                                                                </Box>

                                                            </TableCell>
                                                            {
                                                                data?.paymentDetails?.length > 0 ? (
                                                                    data?.paymentDetails?.map((payment, paymentIndex) => (
                                                                        <TableCell className='tableBodyCell' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderLeft: '1px solid #E9EAEB', }}>
                                                                            <Typography sx={{ flex: 1, fontSize: '12.5px', padding: '5.5px' }}>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                                        {payment?.paymentAmount}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Typography>
                                                                            <Typography sx={{ flex: 1, textAlign: 'left', fontSize: '12.2px', padding: '5.5px' }}>{dayjs(payment?.paymentDate).format('DD-MM-YYYY')}</Typography>
                                                                            <Checkbox
                                                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0.2 }}
                                                                                onChange={(e) => handlePendingCheck(payment)}
                                                                            />
                                                                        </TableCell>
                                                                    ))
                                                                ) : (
                                                                    <TableCell className='tableBodyCell' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderLeft: '1px solid #E9EAEB' }}>
                                                                        <Typography sx={{ flex: 1, fontSize: '12.5px', padding: '28px' }} >
                                                                            No Payments
                                                                        </Typography>
                                                                    </TableCell>
                                                                )
                                                            }
                                                        </TableRow>
                                                    </TableBody>
                                                ))
                                            ) : (<TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={10}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>)
                                        ) : (<TableRow>
                                            <TableCell colSpan={13}>
                                                <Box className='tableloader'>
                                                    <TableLoader />
                                                </Box>
                                            </TableCell>
                                        </TableRow>)
                                    }
                                </Table>
                            </Paper>

                            <Paper sx={{ width: '100%' }}>
                                <Table sx={{ width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" >Refund</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='tableHeadersCell' >Referral Type</TableCell>
                                            <TableCell className='tableHeadersCell' >Rewards</TableCell>
                                            <TableCell className='tableHeadersCell' >
                                                <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <Box sx={{ flex: 1 }}>
                                                        Refund Amount
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        Refund Status
                                                    </Box>
                                                </Grid2>
                                            </TableCell>
                                        </TableRow>

                                    </TableHead>
                                    {
                                        !showTableLoder ? (
                                            refundAmountList?.length > 0 ? (
                                                refundAmountList?.map((data, index) => (
                                                    <TableBody>
                                                        <TableRow key={data?.referralCommissionId}
                                                            sx={{
                                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}>
                                                            <TableCell className='tableBodyCell'>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                    {
                                                                        data?.referralType === "CAN-REF" ? (
                                                                            <img src={BonusIcon} alt="Bonus icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />

                                                                        ) : (
                                                                            <img src={Folders} alt="Folders icon" style={{ width: '25px', height: '25px', marginTop: '8.5px' }} />
                                                                        )
                                                                    }
                                                                    <Typography className='referral-column'><span style={{ fontWeight: 'bold' }}>{data?.referralType}-{dayjs(data?.createdDate).format('YYYY')}-{data?.referralCommissionId}</span>
                                                                        <br></br>
                                                                        {
                                                                            data?.referralType === "CAN-REF" ? (<>
                                                                                {data?.profileName}
                                                                                <br></br>
                                                                                {data?.positionName}
                                                                            </>) : (<>
                                                                                {data?.positionName}
                                                                                <br></br>
                                                                                {data?.profileName}
                                                                            </>)
                                                                        }
                                                                    </Typography>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell className='tableBodyCell'>
                                                                {
                                                                    !data?.commissionType ? "-" : data?.commissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                                }<br></br>

                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                        {data?.commissionAmount}
                                                                    </Typography>
                                                                </Box>

                                                            </TableCell>
                                                            {
                                                                data?.refundDetails?.length > 0 ? (
                                                                    data?.refundDetails?.map((refund, paymentIndex) => (
                                                                        <TableCell className='tableBodyCell' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderLeft: '1px solid #E9EAEB' }}>
                                                                            <Typography sx={{ flex: 1, fontSize: '12.5px', padding: '5.5px' }}>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                                                        {refund?.refundAmount}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Typography>
                                                                            <Typography sx={{ flex: 1, fontSize: '12.5px', padding: '5.5px' }} >
                                                                                <span className={`badge-status ${refund?.refundStatus.toLowerCase()}`}> {refund?.refundStatus}</span>
                                                                            </Typography>
                                                                            <Checkbox
                                                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0.2 }}
                                                                                onChange={(e) => handleRefundChecked(refund)}
                                                                            />
                                                                        </TableCell>
                                                                    ))
                                                                ) : (
                                                                    <TableCell className='tableBodyCell' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderLeft: '1px solid #E9EAEB' }}>
                                                                        <Typography sx={{ flex: 1, fontSize: '12.5px', padding: '28px' }} >
                                                                            No Payments
                                                                        </Typography>
                                                                    </TableCell>
                                                                )
                                                            }
                                                        </TableRow>
                                                    </TableBody>
                                                ))
                                            ) : (<TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={10}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>)
                                        ) : (<TableRow>
                                            <TableCell colSpan={13}>
                                                <Box className='tableloader'>
                                                    <TableLoader />
                                                </Box>
                                            </TableCell>
                                        </TableRow>)
                                    }
                                </Table>
                            </Paper>
                        </Box>
                        <Grid2 sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                            <MUIButton onClick={handleInvoiceOpen} title='Make Invoice' type="submit" sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '130px' }} />

                        </Grid2>
                    </TabPanel> */}

                    {/* <TabPanel value="6" sx={{ display: 'flex', padding: 1.5 }}>
                        <Paper sx={{ width: '100%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='tableHeadersCell' >Invoice Id</TableCell>
                                        <TableCell className='tableHeadersCell' >Invoice Number</TableCell>
                                        <TableCell className='tableHeadersCell' >Created Date</TableCell>
                                        <TableCell className="tableHeadersCell">Amount</TableCell>
                                        <TableCell className="tableHeadersCell">Created By</TableCell>
                                        <TableCell className="tableHeadersCell">Status</TableCell>
                                        <TableCell className="tableHeadersCell">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    !showTableLoder ? (
                                        allInvoiceList?.length > 0 ? (
                                            allInvoiceList?.map((invoice, index) => (
                                                <TableBody>
                                                    <TableRow key={invoice?.invoiceId}
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}>
                                                        <TableCell className='tableBodyCell'>{invoice?.invoiceId}</TableCell>
                                                        <TableCell className='tableBodyCell'>{invoice?.invoiceNumber}</TableCell>
                                                        <TableCell className='tableBodyCell'>{dayjs(invoice?.createdDate).format('DD-MM-YYYY')}</TableCell>
                                                        <TableCell className='tableBodyCell'>{invoice?.totalAmount}</TableCell>
                                                        <TableCell className='tableBodyCell'>{invoice?.createdUserEmailId}</TableCell>
                                                        <TableCell className='tableBodyCell'><span className={`badge-status ${(invoice?.status).toLowerCase()}`}>{invoice?.status}</span></TableCell>
                                                        <TableCell className='tableBodyCell'>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                <Tooltip title="Download"
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    <DownloadIcon className="icons" />
                                                                </Tooltip>

                                                                <Tooltip title="Delete"
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    <InputAdornment position="end">
                                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                            <img src={DeleteIcon} style={{ width: '15px', height: '15px', filter: 'grayscale(100%)', cursor: 'pointer' }} />
                                                                        </div>
                                                                    </InputAdornment>
                                                                </Tooltip>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            ))
                                        ) : (<TableBody>
                                            <TableRow>
                                                <TableCell colSpan={10}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>)
                                    ) : (<TableRow>
                                        <TableCell colSpan={13}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>)
                                }
                                <TableRow>{count <= rowsPerPage ? ("") : (
                                    <TableCell colSpan={100}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <MUICancelButton
                                                title='Previous'
                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                disabled={page === 1}
                                                onClick={() => handleChangePage(null, page - 1)}
                                                sx={{ height: '36px' }}
                                            />
                                            <Pagination
                                                page={page}
                                                onChange={handleChangePage}
                                                count={Math.ceil(count / rowsPerPage)}
                                                siblingCount={3}
                                                boundaryCount={3}
                                                shape="rounded"
                                                hidePrevButton
                                                hideNextButton
                                            />

                                            <MUICancelButton
                                                title='Next'
                                                startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                disabled={page === Math.ceil(count / rowsPerPage)}
                                                onClick={() => handleChangePage(null, page + 1)}
                                                sx={{ height: '36px' }}
                                            />

                                        </div>
                                    </TableCell>)
                                }
                                </TableRow>
                            </Table>
                        </Paper>
                    </TabPanel> */}
                </TabContext>
            </Grid2>



            <Grid2 item>
                <Dialog
                    open={invoiceDialogOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="xs"
                    sx={{
                        "& .MuiDialog-paper": {
                            width: '90%',
                            maxWidth: '600px',  // Adjusted max-width for more space
                            height: 'auto',
                            borderRadius: '15px',
                            padding: '20px',
                        },
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                        <img src={ORLOGO} alt="LOgo" style={{ width: '60px', }}></img>
                        <Typography sx={{ fontWeight: 'bold', fontSize: '30px', color: '#3f51b5' }}> Invoice</Typography>


                    </DialogTitle>
                    <DialogContent >
                        <DialogContentText>
                            <Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '15px', flexWrap: 'wrap' }}>
                                    <Grid2>
                                        <Typography sx={{ fontSize: '14px' }} >{recruiterId} {recruiterFullName}<br></br> {recruiterEmail}</Typography>
                                    </Grid2>

                                    <Grid2>
                                        <Typography sx={{ fontSize: '14px' }} >{recruiterBankName} {recruiterBranchName}<br></br>{recruiterAccountNumber}<br></br>{recruiterIfscCode}</Typography>
                                    </Grid2>
                                </Box>
                            </Box>

                            <Table sx={{ marginTop: '5px' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">Payment ID</TableCell>
                                        <TableCell className="tableHeadersCell">Payment Date</TableCell>
                                        <TableCell className="tableHeadersCell">Payment Status</TableCell>
                                        <TableCell className="tableHeadersCell">Amount</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {Array.from(pendingSet).length > 0 ? (
                                        Array.from(pendingSet).map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell className="tableBodyCell">{data?.paymentId}</TableCell>
                                                <TableCell className="tableBodyCell">{dayjs(data?.paymentDate).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell className="tableBodyCell">{data?.paymentStatus}</TableCell>
                                                <TableCell className="tableBodyCell">{data?.paymentAmount}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={4} className="tableBodyCell">No payments available</TableCell>
                                        </TableRow>
                                    )}

                                    {paymentTotal > 0 && (
                                        <TableRow >
                                            <TableCell className="tableBodyCell" colSpan={3} style={{ textAlign: 'right' }}>
                                                Total Pending Amount
                                            </TableCell>
                                            <TableCell className="tableBodyCell">{paymentTotal}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                            <Table sx={{ marginTop: '20px' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">Refund ID</TableCell>
                                        <TableCell className="tableHeadersCell">Refund Date</TableCell>
                                        <TableCell className="tableHeadersCell">Refund Status</TableCell>
                                        <TableCell className="tableHeadersCell">Amount</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {Array.from(refundSet).length > 0 ? (
                                        Array.from(refundSet).map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell className="tableBodyCell">{data?.refundId}</TableCell>
                                                <TableCell className="tableBodyCell">{dayjs(data?.paymentDate).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell className="tableBodyCell">{data?.refundStatus}</TableCell>
                                                <TableCell className="tableBodyCell">{data?.refundAmount}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={4} className="tableBodyCell">No payments available</TableCell>
                                        </TableRow>
                                    )}

                                    {refundTotal > 0 && (
                                        <TableRow style={{ borderBottom: '2px solid #E9EAEB' }}>
                                            <TableCell className="tableBodyCell" colSpan={3} style={{ textAlign: 'right' }}>
                                                Total Refund Amount
                                            </TableCell>
                                            <TableCell className="tableBodyCell">{refundTotal}</TableCell>
                                        </TableRow>
                                    )}

                                    <TableRow>
                                        <TableCell
                                            className="totalAmountCell"
                                            colSpan={3}>
                                            Total Amount
                                        </TableCell>
                                        <TableCell className="totalAmount">{finalAmount}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            {
                                finalAmount < 0 ? <span style={{ color: 'red', fontSize: '0.8rem', justifyContent: 'flex-end', display: 'flex' }}>Total amount is exceed pending amount</span> : ""
                            }

                            <Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '15px', flexWrap: 'wrap' }}>
                                    <Grid2 sx={{ width: '50%' }}>
                                        <Typography sx={{ fontSize: '14px' }} >Date : {currentDate}</Typography>
                                        <Typography sx={{ fontSize: '14px' }} >Time : {currentTime}</Typography>
                                    </Grid2>
                                    <Grid2 sx={{ width: '50%' }}>
                                        <InputLabel className="inputlabels">INVOICE Number</InputLabel>
                                        <TextField
                                            className="invoiceField"
                                            placeholder="Enter INVOICE Number"
                                            autoComplete="off"
                                            value={invoiceNumber}
                                            onChange={handleGetInvoiceNumber}
                                        />
                                        {isInvoice ?
                                            <span style={{ color: 'red', fontSize: '0.7rem' }}>Invoice number is required</span> : ""
                                        }
                                    </Grid2>
                                </Box>
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ marginTop: '20px', textAlign: 'center', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <MUICancelButton title="Close" onClick={() => {
                            setInvoiceDialogOpen(false)
                            setIsInvoice(false)
                        }}></MUICancelButton>
                        <MUIButton title="Submit" onClick={makeInvoice} />
                    </DialogActions>
                </Dialog>
            </Grid2>

            <Grid2>
                <Dialog
                    open={openHistory}
                    onClose={handleCloseHistory}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        "& .MuiDialog-paper": {
                            minHeight: "85vh",
                            minWidth: "70vw",
                        },
                        marginLeft: "70px",
                    }}
                >
                    <DialogTitle variant="h6">
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                                Payment History
                            </Typography>
                            <CloseIcon
                                sx={{ cursor: "pointer" }}
                                onClick={handleCloseHistory}
                            ></CloseIcon>
                        </Box>
                    </DialogTitle>
                    <DialogContent dividers>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">Updated On</TableCell>
                                        <TableCell className="tableHeadersCell">Installment Due Date</TableCell>
                                        <TableCell className="tableHeadersCell">Name</TableCell>
                                        <TableCell className="tableHeadersCell">Invoice No</TableCell>
                                        <TableCell className="tableHeadersCell">Amount</TableCell>
                                        <TableCell className="tableHeadersCell">Status</TableCell>
                                        <TableCell className="tableHeadersCell">Remarks</TableCell>
                                    </TableRow>
                                </TableHead>

                                {!showLoader ? (
                                    history?.paymentHistory?.length > 0 ? (
                                        <TableBody>
                                            {history?.paymentHistory?.map((item, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                                                        "&:hover": { backgroundColor: "#f1f1f1" },
                                                    }}
                                                >
                                                    <TableCell className="tableBodyCell">
                                                        {dayjs(item.generatedDate).format('DD-MM-YYYY') || '-'}
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell">
                                                        {dayjs(item.paymentDate).format('DD-MM-YYYY') || '-'}
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell">
                                                        {item.generatedUserName || '-'}
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell">
                                                        {item.invoiceNumber || '-'}
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell">
                                                        {item.paymentAmount || '-'}
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell">
                                                        <StatusBadge status={item?.paymentStatus} />
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell" sx={{ width: '20%' }}>
                                                        {item.remarks || "-"}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={10}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                ) : (
                                    <TableCell colSpan={100}>
                                        <Box className="tableloader">
                                            <TableLoader />
                                        </Box>
                                    </TableCell>
                                )}
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <MUICancelButton onClick={handleCloseHistory} title="Close">
                            Close
                        </MUICancelButton>
                    </DialogActions>
                </Dialog>
            </Grid2>
        </Box >
    )
}
export default PaymentHistory;